module.exports = __webpack_public_path__ + "img/c69048c.png";